import React, { createContext, useContext, useLayoutEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useUserStore } from '../../stores/userStore';
import { discoveryApi } from '../../api/discovery';
import { useSearchContinuation } from './continuationArtist';
import { createSearchSession } from './searchSession';
const Context = createContext(null);
export function SearchSessionProvider({ children }) {
  const userId = useUserStore((s) => s.user?.id);
  const scope = String(userId ?? 'guest');
  const location = useLocation();
  const mounted = useRef(true);
  const current = useRef(scope);
  current.current = scope;
  const ref = useRef(null);
  if (!ref.current || ref.current.scope !== scope) {
    ref.current?.session.dispose();
    const session = createSearchSession({
      actor: scope,
      isCurrent: () =>
        mounted.current &&
        current.current === scope &&
        (!useUserStore.getState || String(useUserStore.getState().user?.id ?? 'guest') === scope),
      send: (events, signal) => discoveryApi.recordEvents(events, signal),
    });
    ref.current = { scope, session };
  }
  const session = ref.current.session;
  useLayoutEffect(() => session.observe(location), [session, location]);
  useLayoutEffect(() => {
    mounted.current = true;
    // Cancel synchronously, even if several auth changes happen before React renders.
    const unsubscribe = useUserStore.subscribe?.((state, previous) => {
      if (state.user?.id !== previous.user?.id) {
        session.dispose();
        ref.current = null;
        useSearchContinuation.getState().select(null);
      }
    });
    return () => {
      mounted.current = false;
      session.abortPending();
      unsubscribe?.();
    };
  }, [session]);
  return <Context.Provider value={session}>{children}</Context.Provider>;
}
export const useSearchSession = () => useContext(Context);
